<template>
  <div class="guide-page-warp">
    <div class="guide-page-view" :style="'left:' + (-(index - 1) * 100) + 'vw;'">
      <div v-for="(item, i) in steps" :key="i" class="guide-page-item">
        <div class="guide-page-logo">
          <img src="@/assets/imgs/icon_logo.png" alt="">
        </div>
        <div class="guide-page-title">{{ item.title }}</div>
        <div class="guide-page-tips">{{ item.description }}</div>
        <div class="guide-page-img">
          <img :src="item.image" alt="">
        </div>
      </div>
    </div>
    <div class="guide-page-steps">
      <div v-for="i in 4" :key="i" class="dot" :class="{'current-dot': index === i}"></div>
    </div>
    <div v-if="index === 4" class="guide-page-bottam">
      <div></div>
      <div class="guide-page-done" @click="onHome">{{ i18n.done }}</div>
      <div></div>
    </div>
    <div v-else class="guide-page-bottam">
      <div class="guide-page-skip" @click="onHome">{{ i18n.skip }}</div>
      <img @click="nextStep" src="@/assets/imgs/guide/icon_right.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    i18n() {
      return this.$t("guidePage")
    }
  },
  data() {
    return {
      steps: [],
      index: 1
    }
  },
  methods: {
    nextStep () {
      if (this.index < 4) {
        this.index++
      }
    },
    onHome () {
      this.$router.replace('/')
    }
  },
  mounted () {
    const _this = this
    _this.steps = [{
      title: _this.i18n.title1,
      description: _this.i18n.tips1,
      image: require('@/assets/imgs/guide/img_guide1.png')
    },
    {
      title: _this.i18n.title2,
      description: _this.i18n.tips2,
      image: require('@/assets/imgs/guide/img_guide2.png')
    },
    {
      title: _this.i18n.title3,
      description: _this.i18n.tips3,
      image: require('@/assets/imgs/guide/img_guide3.png')
    },
    {
      title: _this.i18n.title4,
      description: _this.i18n.tips4,
      image: require('@/assets/imgs/guide/img_guide4.png')
    }]
  }
}
</script>

<style lang="less">
.guide-page-warp {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  color: #000;
  position: relative;
  .guide-page-view {
    position: absolute;
    top: 0;
    width: 400vw;
    height: 100vh;
    display: flex;
    background-color: #C7EF1D;
    transition: all 0.5s ease;
    .guide-page-item {
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      background-color: #C7EF1D;
      display: flex;
      flex-direction: column;
      .guide-page-logo {
        padding: 49px 0 20px;
        img {
          width: 180px;
          height: 180px;
          display: block;
          margin: 0 auto;
        }
      }
      .guide-page-title {
        font-size: 44px;
        padding: 0 46px;
      }
      .guide-page-tips {
        flex: 1;
        font-size: 26px;
        padding: 0 46px;
      }
      .guide-page-img {
        padding: 0 0 317px;
        img {
          width: 100vw;
          display: block;
          margin: 0;
        }
      }
    }
  }
  .guide-page-steps {
    position: fixed;
    left: 53px;
    bottom: 200px;
    display: flex;
    .dot {
      width: 12px;
      height: 12px;
      border-radius: 6px;
      background-color: rgba(0, 0, 0, 0.37);
      margin-right: 21px;
    }
    .current-dot {
      width: 81px;
      background-color: #000080;
    }
  }
  .guide-page-bottam {
    position: fixed;
    left: 53px;
    right: 53px;
    bottom: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 90px;
      height: 90px;
    }
    .guide-page-skip {
      padding: 6px 32px;
      font-size: 26px;
      color: #000080;
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 36px;
    }
    .guide-page-done {
      padding: 6px 32px;
      margin: 20px;
      font-size: 26px;
      color: #C7EF1D;
      background-color: #000000;
      border-radius: 16px;
    }
  }
}
</style>
